export function tutorialSeenStorageKey(userId) {
  return `flique.tutorialSeen.${userId}`;
}

/** @returns {boolean} true if the user has dismissed the tutorial or storage is unavailable */
export function isTutorialMarkedSeen(userId) {
  if (!userId || typeof window === 'undefined') return true;
  try {
    return window.localStorage.getItem(tutorialSeenStorageKey(userId)) === '1';
  } catch {
    return true;
  }
}

export function markTutorialSeen(userId) {
  if (!userId || typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(tutorialSeenStorageKey(userId), '1');
  } catch {
    // Private mode / quota — ignore so the app stays usable.
  }
}
